import React, { useEffect, useState } from "react";
import styles from "./EventsPage.module.css";
import HeroSection from "../../sections/HeroSection/HeroSection";
import UpcomingEventsSection from "../../sections/UpcomingEventsSection/UpcomingEventsSection";
import ReservationStrip from "../../components/ReservationStrip/ReservationStrip";
import InstaGrid from "../../sections/InstaGrid/InstaGrid";
import FAQSection from "../../sections/FAQSection/FAQSection";
import FeaturedEvent from "../../components/FeaturedEvent/FeaturedEvent"; // Import the new component

import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import aboutBg from "../../assets/DimoraImages/IMG_0461.jpg";

const EventsPage = () => {
    const [featuredEvent, setFeaturedEvent] = useState(null);
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFeaturedEvent = async () => {
            try {
                const todayString = new Date().toISOString().split("T")[0];
                const q = query(
                    collection(db, "events"),
                    where("featured", "==", true),
                    where("status", "==", "published")
                );

                const snapshot = await getDocs(q);
                const upcomingFeatured = snapshot.docs
                    .map((doc) => ({ id: doc.id, ...doc.data() }))
                    .filter((event) => event.date >= todayString)
                    .sort((a, b) => a.date.localeCompare(b.date));

                setFeaturedEvent(upcomingFeatured.length > 0 ? upcomingFeatured[0] : null);
            } catch (error) {
                console.error("Error fetching featured event:", error);
            }
        };

        fetchFeaturedEvent();
    }, []);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const snapshot = await getDocs(collection(db, "faqs", "events", "items"));
                const items = snapshot.docs
                    .map((doc) => ({ id: doc.id, ...doc.data() }))
                    .sort((a, b) => a.order - b.order);

                if (items.length > 0) {
                    setFaqData([{
                        section: "Event Related Questions",
                        items: items.map((item) => ({
                            question: item.question,
                            answer: item.answer,
                        })),
                    }]);
                }
            } catch (error) {
                console.error("Error fetching FAQs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchFaqs();
    }, []);

    const formatDate = (dateStr, timeStr) => {
        if (!dateStr) return "";
        const dateObj = new Date(dateStr);
        const formattedDate = dateObj.toLocaleDateString("en-GB", {
            weekday: "short", day: "2-digit", month: "short",
        });

        let formattedTime = "";
        if (timeStr) {
            const [hours, minutes] = timeStr.split(":");
            const temp = new Date();
            temp.setHours(hours); temp.setMinutes(minutes);
            formattedTime = temp.toLocaleTimeString("en-US", {
                hour: "2-digit", minute: "2-digit", hour12: true,
            });
        }
        return `${formattedDate} · ${formattedTime}`;
    };

    return (
        <div>
            <HeroSection backgroundImage={aboutBg} />
            <section className={styles.section}>
                {featuredEvent && (
                    <FeaturedEvent event={featuredEvent} formatDate={formatDate} />
                )}
                <UpcomingEventsSection />
                <ReservationStrip />
                <InstaGrid />
                {!loading && faqData.length > 0 && (
                    <FAQSection faqData={faqData} />
                )}
            </section>
        </div>
    );
};

export default EventsPage;